export default {
    state: {
        pufIsLandingPageViewed: null,
        pufIsPatientVerified: null,
        pufIsConsented: null,
        pufIsCostReviewed: null,
        pufIsComplete: null,
        pufToken: null,
        pufDob: null,
        pufFirstName: null,
        pufLastName: null,
        pufZip: null,
        showPufValidationError: false,
        maxPufValidationAttempts: 5,
        currentPufValidationAttempts: 0,
        braintreeClientToken: "",
        xifinConfig: null,
        xifinPrepaymentToken: null,
        prepaymentTokenExp: 0,
        amount: null,
        isPrepayment: null
    },
    getters: {
        pufIsLandingPageViewed: state => {
            return state.pufIsLandingPageViewed;
        },
        pufIsPatientVerified: state => {
            return state.pufIsPatientVerified;
        },
        pufIsCostReviewed: state => {
            return state.pufIsCostReviewed;
        },
        pufIsConsented: state => {
            return state.pufIsConsented;
        },
        pufIsComplete: state => {
            return state.pufIsComplete;
        },
        pufToken: state => {
            return state.pufToken;
        },
        pufDob: state => {
            return state.pufDob;
        },
        pufFirstName: state => {
            return state.pufFirstName;
        },
        pufLastName: state => {
            return state.pufLastName;
        },
        pufZip: state => {
            return state.pufZip;
        },
        showPufValidationError: state => {
            return state.showPufValidationError;
        },
        maxPufValidationAttempts: state => {
            return state.maxPufValidationAttempts;
        },
        currentPufValidationAttempts: state => {
            return state.currentPufValidationAttempts;
        },
        braintreeClientToken: state => {
            return state.braintreeClientToken;
        },
        xifinConfig: state => {
            return state.xifinConfig;
        },
        xifinPrepaymentToken: state => {
            return state.xifinPrepaymentToken;
        },
        prepaymentTokenExp: state => {
            return state.prepaymentTokenExp;
        },
        amount: state => {
            return state.amount;
        },
        isPrepayment: state => {
            return state.xifinConfig !== null &&
                state.xifinConfig !== undefined &&
                state.xifinPrepaymentToken !== null &&
                state.xifinPrepaymentToken !== undefined;
        },
        remainingPufValidationAttempts: state => {
            return Math.max(
                state.maxPufValidationAttempts - state.currentPufValidationAttempts,
                0
            );
        },
        hitMaxPufValidationAttempts: state => {
            return state.currentPufValidationAttempts >= state.maxPufValidationAttempts;
        }
    },
    mutations: {
        setPufIsLandingPageViewed(state, value) {
            state.pufIsLandingPageViewed = value;
        },
        setPufIsPatientVerified(state, value) {
            state.pufIsPatientVerified = value;
        },
        setPufIsCostReviewed(state, value) {
            state.pufIsCostReviewed = value;
        },
        setPufIsConsented(state, value) {
            state.pufIsConsented = value;
        },
        setPufIsComplete(state, value) {
            state.pufIsComplete = value;
        },
        setPufToken(state, token) {
            state.pufToken = token;
        },
        setPufDob(state, value) {
            state.pufDob = value;
        },
        setPufFirstName(state, value) {
            state.pufFirstName = value;
        },
        setPufLastName(state, value) {
            state.pufLastName = value;
        },
        setPufZip(state, value) {
            state.pufZip = value;
        },
        setShowPufValidationError(state, value) {
            state.showPufValidationError = value;
        },
        setPufValidationAttempts(state, {maxAttempts, attempts}) {
            state.maxPufValidationAttempts = maxAttempts;
            state.currentPufValidationAttempts = attempts;
        },
        setIsManualInsurance(state, value) {
            state.isManualInsurance = value;
        },
        setBraintreeClientToken(state, value) {
            state.braintreeClientToken = value;
        },
        setXifinConfig(state, value) {
            state.xifinConfig = value;
        },
        setXifinPrepaymentToken(state, value) {
            state.xifinPrepaymentToken = value;
        },
        setPrepaymentTokenExp(state, value) {
            state.prepaymentTokenExp = value;
        },
        setAmount(state, value) {
            state.amount = value;
        }
    },
    actions: {
        setPufIsLandingPageViewed(context, value) {
            context.commit("setPufIsLandingPageViewed", value);
        },
        setPufIsPatientVerified(context, value) {
            context.commit("setPufIsPatientVerified", value);
        },
        setPufIsCostReviewed(context, value) {
            context.commit("setPufIsCostReviewed", value);
        },
        setPufIsConsented(context, value) {
            context.commit("setPufIsConsented", value);
        },
        setPufIsComplete(context, value) {
            context.commit("setPufIsComplete", value);
        },
        setPufToken(context, token) {
            context.commit("setPufToken", token);
        },
        setPufDob(context, value) {
            context.commit("setPufDob", value);
        },
        setPufFirstName(context, value) {
            context.commit("setPufFirstName", value);
        },
        setPufLastName(context, value) {
            context.commit("setPufLastName", value);
        },
        setPufZip(context, value) {
            context.commit("setPufZip", value);
        },
        setShowPufValidationError(context, value) {
            context.commit("setShowPufValidationError", value);
        },
        setPufValidationAttempts(context, {maxAttempts, attempts}) {
            context.commit("setPufValidationAttempts", {maxAttempts, attempts});
        },
        setBraintreeClientToken(context, value) {
            context.commit("setBraintreeClientToken", value);
        },
        setXifinConfig(context, value) {
            context.commit("setXifinConfig", value);
        },
        setXifinPrepaymentToken(context, value) {
            context.commit("setXifinPrepaymentToken", value);
        },
        setPrepaymentTokenExp(context, value) {
            context.commit("setPrepaymentTokenExp", value);
        },
        setAmount(context, value) {
            context.commit("setAmount", value);
        }
    }
};
